export default __webpack_public_path__ + "static/media/015-road.62ffcf76.svg";